module.exports = __webpack_public_path__ + "static/img/img1.6009da8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/public/img1.png
// module id = iyqz
// module chunks = 3